<div class="item" *ngIf="group">

    <div
        class="main-title">{{ group.englishLevel }}
    </div>
    <div class="teaser">{{ group.ageGroup }} {{ ('certificateComp.school' | transloco) }} </div>

    <div class="result-wrapper">

        <div class="info">
            <div class="title">{{ ('certificateComp.yourResult' | transloco) }}:</div>
            <div class="result">{{ group.final }}/100</div>
        </div>

        <div class="image-container">
            <img src="assets/images/icons/certificate.svg"
                 alt="certificate">
        </div>
    </div>

    <ion-row
        class="type-title ion-no-padding ion-no-margin statistic-wrapper bg-{{group.color}}">

<!--        <ion-col size="12"-->
<!--                 class="ion-justify-content-center  title bg-{{group.color}}">{{ group.title|transloco }}-->
<!--        </ion-col>-->

        <ion-col size="12"
                 class="ion-justify-content-center  title bg-{{group.color}}">{{ group.title }}
        </ion-col>
        <ion-col size="6" class="statistic">
            <div class="statistic-title">
                {{ ('certificateComp.attendance' | transloco) }}
            </div>

            <div class="result">

                <img src="assets/images/icons/done_grey.svg" alt="done"/>

                {{ group.attendance }}

            </div>
        </ion-col>
        <ion-col size="6" class="statistic">

            <div class="statistic-title">
                 {{ ('certificateComp.period' | transloco) }}
            </div>

            <div class="result">

                <img src="assets/images/icons/calendar.svg" alt="date"/>

                {{ group.period }}

            </div>
        </ion-col>

    </ion-row>

    <button class="btn dark-btn" *ngIf="group.certificate"
            (click)="openCertificate(group.certificate)">

        {{ ('certificateComp.watch' | transloco) }}
    </button>


</div>
